import { Route } from "react-router-dom";
import Presentation from "../pages/blog/Presentation";

const blogRoutes = [
  {
    name: "Presentation",
    path: "/blog/presentacion",
    element: <Presentation />,
  },
];

export const BlogRoutes = () => {
  return blogRoutes.map((route, index) => {
    return (
      <Route key={route} path={route.path} element={route.element}></Route>
    );
  });
};
